import { createTypes } from 'redux-create-types';
import { ajaxJson, ajaxFD } from 'imports/ajax';
import { 
    map2CourseObj,
    map2ChapterObj,
    map2programObj,
    map2Quiz,
    map2QuizResult,
    map2Project,
    map2Event
} from 'imports/mapper';
import { courseActionCreators } from 'db/course/course.action';
import { programActionCreators } from 'db/program/program.action';
import { unitActionCreators } from 'db/unit/unit.action';
import { quizActionsCreators } from 'db/quiz/quiz.action';
import { questionActionsCreators } from 'db/question/question.action';
import { choiceActionsCreators } from 'db/choice/choice.action';
import { confirmAlert } from 'react-confirm-alert';
import { projectActionsCreators } from 'db/project/project.action';
import { eventActionsCreators } from 'db/event/event.action';
import { coursePageActionsCreators } from '../../CourseActions';
import { orm, dbStateSelector } from 'db';
import { createSelector } from 'redux-orm';
import { projectSelectorFnMaker, currentUnitSelectorFnMaker, unitsSelectorFnMaker } from './ExecuteSelectors';
import axios from 'axios';
import { toast } from 'react-toastify';



const namespace = 'page-courseExecute';

export const executeActions = createTypes([
    'toggleSpinner',
    'setError',
    'setQuizStatus',
    'selectChapter',
    'deselectChapter',
    'selectSection',
    'deselectSection',
    'selectUnit',
    'deselectUnit',
    'selectProject',
    'deselectProject',
    'selectEvent',
    'deselectEvent',
    'deselectAll',
    'setCancelTokenSource',
    'setIsWrongFlagForVideoAttachmentQuestion'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: executeActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: executeActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function deselectAll() {
    return dispatch => {
        dispatch({
            type: executeActions.deselectAll,
        })
    }
}

function selectProject(projectId) {
    return (dispatch, getState) => {
        const state = getState();
        const selectedProject = createSelector(orm, dbStateSelector, projectSelectorFnMaker(projectId))(state);
        const breadCrumbItems = [
            {
                title: selectedProject.chapter.courseTitle,
                order: 0,
            },
            {
                title: selectedProject.chapter.title,
                order: 1,
            },
            {
                title: selectedProject.title,
                order: 2
            }
        ]
        dispatch(coursePageActionsCreators.setBreadCrumb(breadCrumbItems));
        dispatch({
            type: executeActions.selectProject,
            payload: projectId,
        })
    }
}

function deselectProject() {
    return dispatch => {
        dispatch({
            type: executeActions.deselectProject,
        })
    }
}

function selectEvent(event) {
    return dispatch => {
        dispatch({
            type: executeActions.selectEvent,
            payload: event.id,
        })
    }
}

function deselectEvent() {
    return dispatch => {
        dispatch({
            type: executeActions.deselectEvent,
        })
    }
}

function selectAllThingToShowUnit(unitId, unitType, courseId, programId) {
    return (dispatch, getState) => {
        const selectedItems = createSelector(orm, dbStateSelector, currentUnitSelectorFnMaker(unitId))(getState());
        dispatch({
            type: executeActions.selectChapter,
            payload: selectedItems.selectedChapter
        });
        dispatch({
            type: executeActions.selectSection,
            payload: selectedItems.selectedSection
        });
        dispatch(selectUnit(selectedItems.selectedUnit));
        switch (unitType) {
            case 'file':
                dispatch(selectPdfUnit(programId, courseId, unitId));
                break;
            case 'video':
                dispatch(selectVideoUnit(programId, courseId, unitId));
                break;
            case 'quiz':
                dispatch(getQuizStatusFromApi(programId, courseId, unitId));
                break;
            default:
                return Promise.reject('محتوای این واحد ناقص است.');
        }
    }
}

function getCurrentUnitApiSuccess(res, courseId, programId) {
    return (dispatch, getState) => {
        const unitId = res.data['uid'];
        const unitType = res.data['content_type'];
        dispatch(selectAllThingToShowUnit(unitId, unitType, courseId, programId))
    }
}

function getCurrentUnitApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'current-unit'
            }
        })
        return dispatch(hideSpinner('current-unit'))
    }
}

function getCurrentUnitFromApi(courseId, programId) {
    return dispatch => {
        dispatch(showSpinner('current-unit'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/current_unit`)
        .then(
            res => dispatch(getCurrentUnitApiSuccess(res, courseId, programId)),
            err => dispatch(getCurrentUnitApiFail(err))
        )
        .then(() => {
            return dispatch(hideSpinner('current-unit'));            
        })
    }
}

function getChaptersApiSuccess(res, courseId, programId) {
    return dispatch => {
        res.data.forEach((chapter) => {
            const chapterObj = map2ChapterObj(chapter);
            dispatch(courseActionCreators.addChapter(chapterObj, courseId));
            chapter['events'].forEach((event) => {
                dispatch(eventActionsCreators.save({
                    ...event,
                    chapter: chapter['uid'],
                }));
            });
            chapter['projects'].forEach((project) => {
                const projectObj = map2Project(project);
                dispatch(projectActionsCreators.save({
                    ...projectObj,
                    chapter: chapter['uid'],
                }));
            });
        });
        return Promise.resolve();
    }
}

function getChaptersApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'chapters'
            }
        })
        return dispatch(hideSpinner('chapters'));
    }
}

function getChaptersFromApi(courseId, programId) {
    return dispatch => {
        dispatch(showSpinner('chapters'));
        return ajaxJson.get(`programs/${programId}/courses/${courseId}/chapters`)
        .then(
            res => dispatch(getChaptersApiSuccess(res, courseId, programId)),
            err => dispatch(getChaptersApiFail(err)),
        ).then((promise) => {
            dispatch(hideSpinner('chapters'));            
            return promise;
        })
    }
}

function getCourseApiSuccess(res, courseId, programId) {
    return dispatch => {
        const courseObj = map2CourseObj(res.data);
        dispatch(courseActionCreators.save(courseObj));
        // TODO: update breadcrumb
        return dispatch(getChaptersFromApi(courseId, programId));
        
    }
}

function getCourseApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'course'
            }
        })
        return dispatch(hideSpinner('course'));
    }
}

function getCourseFromApi(courseId, programId) {
    return dispatch => {
        dispatch(showSpinner('course'));
        return ajaxJson.get(`/courses/${courseId}`)
        .then(
            res => dispatch(getCourseApiSuccess(res, courseId, programId)),
            err => dispatch(getCourseApiFail(err)),
        ).then((promise) => {
            dispatch(hideSpinner('course'));
            return promise
        })
    }
}

function getProgramApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'program'
            }
        })
        return dispatch(hideSpinner('program'));
    }
}

function getProgramApiSuccess(res) {
    return dispatch => {
        const programObj = map2programObj(res.data);
        dispatch(programActionCreators.save(programObj))
        return dispatch(hideSpinner('program'));
    }
}

function getProgramFromApi(programId) {
    return dispatch => {
        dispatch(showSpinner('program'));
        return ajaxJson.get(`/programs/${programId}`)
        .then(
            res => dispatch(getProgramApiSuccess(res)),
            err => dispatch(getProgramApiFail(err))
        )
    }
}

function getPdfUnitContentApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'pdf-content'
            }
        })
        return dispatch(hideSpinner('pdf-content'));
    }
}

function getPdfUnitContentApiSuccess(res, unitId) {
    return dispatch => {
        const unitDetailObject = {
            id: res.data.uid,
            filePath: res.data.file, 
            title: res.data.title,
        }
        dispatch(unitActionCreators.savePdfUnit(unitDetailObject, unitId));
        return dispatch(hideSpinner('pdf-content'));
    }
}

function getPdfUnitContentFromApi(programId, courseId, unitId) {
    return dispatch => {
        dispatch(showSpinner('pdf-content'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/units/file/${unitId}`)
        .then(
            res => dispatch(getPdfUnitContentApiSuccess(res, unitId)),
            err => dispatch(getPdfUnitContentApiFail(err)),
        )
    }
}

function selectPdfUnit(programId, courseId, unitId) {
    return dispatch => {
        const setSeenFlag = dispatch(unitActionCreators.setSeenUnitFlag(unitId, true));
        const getContent = dispatch(getPdfUnitContentFromApi(programId, courseId, unitId))
        return Promise.all([setSeenFlag, getContent]);
    }
}

function getVideoUnitContentApiSuccess(res, unitId) {
    return dispatch => {
        const unitDetailObject = {
            id: res.data.uid,
            filePath: res.data.video, 
            title: res.data.title,
            currentTime: res.data.metadata['last_seen_time'],
            attachments: res.data.attachments,
        }
        dispatch(unitActionCreators.saveVideoUnit(unitDetailObject, unitId))
        return dispatch(hideSpinner('video-content'));
    }
}

function getVideoUnitContentApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'video-content'
            }
        })
        return dispatch(hideSpinner('video-content'));
    }
}

function getVideoUnitContentFromApi(programId, courseId, unitId) {
    return dispatch => {
        dispatch(showSpinner('video-content'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/units/video/${unitId}`)
        .then(
            res => dispatch(getVideoUnitContentApiSuccess(res, unitId)),
            err => dispatch(getVideoUnitContentApiFail(err)),
        )
    }
}

function selectVideoUnit(programId, courseId, unitId) {
    return dispatch => {
        return dispatch(getVideoUnitContentFromApi(programId, courseId, unitId))
    }
}

function getQuizAttemptApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'quiz-content'
            }
        })
        return dispatch(hideSpinner('quiz-content'));
    }
}

function selectAllSelectedChoice(quizResultObj) {
    return dispatch => {
        quizResultObj.selectedChoice.forEach(sc => {
            const selectedChoiceId = sc.questionId + sc.choice;
            if (sc.choice !== null) {
                dispatch(choiceActionsCreators.selectChoice(selectedChoiceId));
            }
        });
    }
}

function checkAllQuizQuestionAnswers(answers) {
    return dispatch => {
        let checkQuestionsDispatches = answers.map(answer => {
            const answerChoiceId = answer.questionId + answer.correctChoice;
            return dispatch(questionActionsCreators.checkQuestion(answer.questionId, answerChoiceId, answer.hint));
        });
        return Promise.all(checkQuestionsDispatches);
    }
}

function getQuizAttemptApiSuccess(res, unitId) {
    return dispatch => {
        const quizResultObj = map2QuizResult(res.data);
        const dispatch1 = dispatch(selectAllSelectedChoice(quizResultObj));
        const dispatch2 = dispatch(quizActionsCreators.setQuizProgress(
            unitId,
            quizResultObj.grade,
            quizResultObj.correctCount,
            quizResultObj.wrongCount,
            quizResultObj.notAnsweredCount
        ));
        const dispatch3 = dispatch(checkAllQuizQuestionAnswers(quizResultObj.answers));
        return Promise.all([dispatch1, dispatch2, dispatch3]);
    }
}

function getQuizAttemptFromApi(programId, courseId, unitId) {
    return dispatch => {        
        dispatch(showSpinner('quiz-content'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/units/quiz/${unitId}/attempt`)
        .then(
            res => dispatch(getQuizAttemptApiSuccess(res, unitId)),
            err => dispatch(getQuizAttemptApiFail(err)),
        )
        .then(() => {
            return dispatch(hideSpinner('quiz-content'));
        })
    }
}

function getQuizUnitContentApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'quiz-content'
            }
        })
        return dispatch(hideSpinner('quiz-content'));
    }
}

function getQuizUnitContentApiSuccess(res, programId, courseId, unitId) {
    return dispatch => {
        const quizObj = map2Quiz(res.data);
        dispatch(unitActionCreators.saveQuizUnit(quizObj, unitId));
        if (quizObj.status === 'time-finished' || quizObj.status === 'answered') {
            dispatch(getQuizAttemptFromApi(programId, courseId, unitId));
        } else {
            return dispatch(hideSpinner('quiz-content'));
        }
    }
}

function getQuizUnitContentFromApi(programId, courseId, unitId) {
    return dispatch => {
        dispatch(showSpinner('quiz-content'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/units/quiz/${unitId}`)
        .then(
            res => dispatch(getQuizUnitContentApiSuccess(res, programId, courseId, unitId)),
            err => dispatch(getQuizUnitContentApiFail(err)),
        )
    }
}

function selectQuizUnit(programId, courseId, unitId) {
    return dispatch => {
        const setSeenFlag = dispatch(unitActionCreators.setSeenUnitFlag(unitId, true));
        const getContent = dispatch(getQuizUnitContentFromApi(programId, courseId, unitId));
        return Promise.all([setSeenFlag, getContent]);
    }
}

function getQuizStatusApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'quiz-status'
            }
        })
        return dispatch(hideSpinner('quiz-status'));
    }
}


// TODO: Not Implement yet
function unSelectUnit() {
    return dispatch => {
        return dispatch({
            type: 'asd',
        })
    }
}

function confirmForStartQuiz(programId, courseId, unitId) {
    return dispatch => {
        confirmAlert({
            title: 'شروع آزمون',
            message: 'در صورت اطمینان از اجرای آزمون لطفا تایید بفرمایید.',
            buttons: [
                {
                    label: 'بلی',
                    onClick: () => {
                        dispatch(selectQuizUnit(programId, courseId, unitId));
                    }
                },
                {
                    label: 'خیر',
                    onClick: () => {
                        dispatch(unSelectUnit());
                    }
                }
            ]
        })
    }
}

function getQuizStatusApiSuccess(res, programId, courseId, unitId) {
    return dispatch => {
        let status = null;
        switch (res.data.status) {
            case 'not-started':
                status = 'not-started';
                break;
            case 'started':
                status = 'started';
                break;
            case 'time-finished':
                status = 'time-finished';
                break;
            case 'answered':
                status = 'answered';
                break;
            default:
                status = null;
                throw new Error('unknown status string');
        }
        if (status) {
            if (status === "not-started") {
                dispatch(confirmForStartQuiz(programId, courseId, unitId));
            } else {
                dispatch(selectQuizUnit(programId, courseId, unitId));
            }
            dispatch({
                type: executeActions.setQuizStatus,
                payload: status
            })
            return dispatch(hideSpinner('quiz-status'));
        } else {
            return dispatch(hideSpinner('quiz-status'));
        }
    }
}

function getQuizStatusFromApi(programId, courseId, unitId) {
    return dispatch => {
        dispatch(showSpinner('quiz-status'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/units/quiz/${unitId}/status`)
        .then(
            res => dispatch(getQuizStatusApiSuccess(res, programId, courseId, unitId)),
            err => dispatch(getQuizStatusApiFail(err)),
        )
    }
}

function postQuizAnswersApiSuccess(res, unitId) {
    return dispatch => {
        const quizResultObj = map2QuizResult(res.data);
        const dispatch1 = dispatch(quizActionsCreators.setQuizProgress(
            unitId,
            quizResultObj.grade,
            quizResultObj.correctCount,
            quizResultObj.wrongCount,
            quizResultObj.notAnsweredCount
        ));
        const dispatch2 = dispatch(checkAllQuizQuestionAnswers(quizResultObj.answers));
        return Promise.all([dispatch1, dispatch2]).then(() => {
            dispatch(showSpinner('submit-answer'));
        });
    }
}

function postQuizAnswersApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'submit-answer'
            }
        })
        return dispatch(hideSpinner('submit-answer'));
    }
}

function postQuizAnswersToApi(answers, programId, courseId, unitId) {
    return dispatch => {
        const bodyData = {
            "answers": answers,
        };
        return ajaxJson.post(`/programs/${programId}/courses/${courseId}/units/quiz/${unitId}/submit`, bodyData)
        .then(
            res => dispatch(postQuizAnswersApiSuccess(res, unitId)),
            err => dispatch(postQuizAnswersApiFail(err)),
        )
    }
}

function submitQuizAnswers(answers, programId, courseId, unitId) {
    return dispatch => {
        dispatch(showSpinner('submit-answer'));
        console.log(answers)
        const mapAnswers = answers.map((a) => {
            return {
                "question_uid": a.question,
                // "answer_choice": `choice_${a.choice + 1}`,
                "answer_choice": a.choice
            }
        });
        
        return dispatch(postQuizAnswersToApi(mapAnswers, programId, courseId, unitId));
    }
}

function postVideoSeenStateApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'video-seen-status'
            }
        });
    }
}

function postVideoSeenStateApiSuccess(res, unitId, seenPercentage) {
    return dispatch => {
        if (seenPercentage >= 50) {
            dispatch(unitActionCreators.setSeenUnitFlag(unitId, true));
        }
    }
}

function postVideoSeenStateToApi(state, programId, courseId, unitId) {
    return dispatch => {
        const bodyData = {
            'seen_percentage': state.seenPercentage,
            'current_time': state.currentTime,
        }
        return ajaxJson.post(`/programs/${programId}/courses/${courseId}/units/video/${unitId}/visit_status`, bodyData)
        .then(
            res => dispatch(postVideoSeenStateApiSuccess(res, unitId, state.seenPercentage)),
            err => dispatch(postVideoSeenStateApiFail(err)),
        )
    }
}

function selectChapter(selectedChapter) {
    return (dispatch, getState) => {
        const oldChapterState = getState().ui.courseExecute.chapter;
        if (!selectedChapter || !selectedChapter.id) {
            return;
        }
        
        if (oldChapterState === null || oldChapterState === undefined || selectedChapter.id !== oldChapterState.id) {
            dispatch({
                type: executeActions.selectChapter,
                payload: selectedChapter
            })
        } else if (selectedChapter.id === oldChapterState.id) {
            dispatch({
                type: executeActions.deselectChapter,
            })
        }
    }
}

function selectSection(selectedSection) {
    return (dispatch, getState) => {
        dispatch(deselectEvent());
        dispatch(deselectProject());
        const oldSectionState = getState().ui.courseExecute.section;
        if (!selectedSection || !selectedSection.id) {
            return;
        }
        if (oldSectionState === null || oldSectionState === undefined || selectedSection.id !== oldSectionState.id) {
            dispatch({
                type: executeActions.selectSection,
                payload: selectedSection
            })
        }
    }
}

function deselectSection(selectedSection) {
    return (dispatch, getState) => {
        dispatch({
            type: executeActions.deselectSection,
            payload: selectedSection
        })
    }
}

function selectUnit(selectedUnit) {
    return (dispatch, getState) => {
        dispatch(deselectEvent());
        dispatch(deselectProject());
        const oldUnitState = getState().ui.courseExecute.unit;
        if (!selectedUnit || !selectedUnit.id) {
            return;
        }
        if (oldUnitState === null || oldUnitState === undefined || selectedUnit.id !== oldUnitState.id) {
            dispatch({
                type: executeActions.selectUnit,
                payload: selectedUnit
            })
        }
    }
}

function getProjectDetailApiSuccess(res) {
    return dispatch => {
        let fetchProject = map2Project(res.data);
        dispatch(projectActionsCreators.save(fetchProject));
        dispatch(selectProject(fetchProject.id));
    }
}

function getProjectDetailApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'get-project'
            }
        });
    }
}

function getProjectDetailFromApi(project) {
    return dispatch => {
        dispatch(showSpinner('get-project'));
        return ajaxJson.get(`/projects/${project.id}`)
        .then(
            (res) => dispatch(getProjectDetailApiSuccess(res)),
            (err) => dispatch(getProjectDetailApiFail(err)),
        )
        .then(() => {
            return dispatch(hideSpinner('get-project'));
        })
    }
}

function setProjectStatus(statusNumber, projectId) {
    return dispatch => {
        switch(statusNumber) {
            case 0:
                dispatch(projectActionsCreators.setStatus('empty', projectId));
                break;
            case 1:
                dispatch(projectActionsCreators.setStatus('uploading', projectId));
                break;
            case 2: 
                dispatch(projectActionsCreators.setStatus('uploaded', projectId));
                break;
            default:
                dispatch(projectActionsCreators.setStatus('empty', projectId));
        }
    }
}

function setProjectFileName(fileName, projectId) {
    return dispatch => {
        const minFileName = (fileName.length > 20) ? fileName.slice(0, 10)+'...'+fileName.slice(fileName.length-10) : fileName;
        dispatch(projectActionsCreators.setFileName(minFileName, projectId));
    }
}

function uploadProject(projectFile) {
    return (dispatch, getState) => {
        const state = getState();
        const projectId = state.ui.courseExecute.selectedProjectId;
        const formData = new FormData();
        formData.append('file', projectFile);
        dispatch(setProjectFileName(projectFile.name, projectId));
        dispatch(uploadProjectToApi(formData, projectId));
    }
}

function setCancelTokenSource(cancelTokenSource, projectId) {
    return dispatch => {
        dispatch({
            type: executeActions.setCancelTokenSource,
            payload: cancelTokenSource,
            meta: {
                projectId,
            }
        })
    }
}

function uploadProjectToApi(formData, projectId) {
    return dispatch => {
        const cancelTokenSource = axios.CancelToken.source();
        dispatch(setCancelTokenSource(cancelTokenSource, projectId));
        dispatch(setProjectStatus(1, projectId));
        ajaxFD.post(`/projects/${projectId}/user_projects`, formData, {
            onUploadProgress: (progressEvent) => {
                const progress = Math.trunc((progressEvent.loaded / progressEvent.total) * 100);
                dispatch(uploadProjectProgress(progress, projectId));
            },
            cancelToken: cancelTokenSource.token
        })
        .then(
            (res) => dispatch(uploadProjectApiSuccess(res, projectId)),
            (err) => dispatch(uploadProjectApiFail(err, projectId)),
        )
    }
}

function uploadProjectProgress(progress, projectId) {
    return dispatch => {
        dispatch(projectActionsCreators.setProgress(progress, projectId));
    }
}

function uploadProjectApiSuccess(res, projectId) {
    return dispatch => {
        dispatch(setProjectStatus(2, projectId));
    }
}

function uploadProjectApiFail(err, projectId) {
    return dispatch => {
        if (axios.isCancel(err)) {
            dispatch(setProjectStatus(0, projectId));            
        } else {
            if (err.response && err.response.status === 400) {
                toast.error('فایل خود را به صورت فشرده (zip یا rar) بارگذاری نمایید', { autoClose: false })
            }
            dispatch(setProjectStatus(0, projectId));            
        }
    }
}

function cancelProjectUploading(projectId) {
    return (dispatch, getState) => {
        getState().ui.courseExecute.cancelSources[projectId].cancel('بارگذاری فایل توسط کاربر لغو گردید.');
    }
}

function getEventDetailApiSuccess(res) {
    return dispatch => {
        const eventObj = map2Event(res.data);
        dispatch(eventActionsCreators.save(eventObj));
        dispatch(deselectProject());
        dispatch(selectEvent(eventObj));
    }
}

function getEventDetailApiFail(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'video-seen-status'
            }
        });
    }
}

function getEventDetailFromApi(eventId) {
    return dispatch => {
        dispatch(showSpinner('get-event'))
        ajaxJson.get(`/events/${eventId}`)
        .then(
            res => dispatch(getEventDetailApiSuccess(res)),
            err => dispatch(getEventDetailApiFail(err)),
        )
        .then(() => {
            return dispatch(hideSpinner('get-event'));
        });
    }
}

function sendSelectedChoice(programId, courseId) {
    return (dispatch, getState) => {
        const state = getState();
        const selectedUnit = state.ui.courseExecute.unit;
        const unitsSelector = selectedUnit ? createSelector(orm, dbStateSelector, unitsSelectorFnMaker(selectedUnit.type, selectedUnit.id)) : null;
        let selectedUnitContent = null;
        if (unitsSelector) {
            selectedUnitContent = unitsSelector(state)
        }
        if (selectedUnitContent) {
            const answers = selectedUnitContent.questions.filter(item => {
                return item.choices.filter(i => i.isCheck).length > 0
            }).map(item => {
                return {
                    'question_uid':  item.id,
                    'answer_choice': item.choices.find(i => i.isCheck).id.slice(item.id.length)
                }
            })
            ajaxJson.post(`programs/${programId}/courses/${courseId}/units/quiz/${selectedUnitContent.unit.id}/save_answer`, {
                answers: answers, 
            });
        }
    }
}

function sendVideoAttachmentQuestionAnswerSuccess(res, cb) {
    return dispatch => {
        if (res.data['answers_stat']['correct'] > 0) {
            dispatch(setIsWrongFlagForVideoAttachmentQuestion(false));
            cb()
        } else {
            dispatch(setIsWrongFlagForVideoAttachmentQuestion(true));
        }
    }
}

function sendVideoAttachmentQuestionAnswerFailed(err) {
    return dispatch => {
        dispatch({
            type: executeActions.setError,
            payload: err,
            meta: {
                apiName: 'send-video-attachment-question-answer'
            }
        });
    }
}

function sendVideoAttachmentQuestionAnswer(programId, courseId, unitId, attachmentId, questionId, selectedChoice, cb) {
    return (dispatch) => {
        dispatch(showSpinner('send-video-attachment-question-answer'))
        ajaxJson.post(`/programs/${programId}/courses/${courseId}/units/${unitId}/attachments/${attachmentId}/quiz/submit`, {
            answers: [{
                "answer_choice": selectedChoice,
                "question_uid": questionId,
            }],
        })
        .then(
            res => dispatch(sendVideoAttachmentQuestionAnswerSuccess(res, cb)),
            err => dispatch(sendVideoAttachmentQuestionAnswerFailed(err)),
        )
        .then(() => {
            return dispatch(hideSpinner('send-video-attachment-question-answer'));
        });
    }
}

function setIsWrongFlagForVideoAttachmentQuestion(flag) {
    return dispatch => {
        dispatch({
            type: executeActions.setIsWrongFlagForVideoAttachmentQuestion,
            payload: flag
        })
    }
}

export const courseExecuteActionsCreator = {
    getCourseFromApi,
    getProgramFromApi,
    selectPdfUnit,
    selectVideoUnit,
    selectQuizUnit,
    getQuizStatusFromApi,
    submitQuizAnswers,
    postVideoSeenStateToApi,
    selectChapter,
    selectSection,
    selectUnit,
    selectProject,
    selectEvent,
    deselectAll,
    deselectProject,
    deselectEvent,
    getProjectDetailFromApi,
    uploadProject,
    cancelProjectUploading,
    getEventDetailFromApi,
    deselectSection,
    selectAllThingToShowUnit,
    getCurrentUnitFromApi,
    sendSelectedChoice,
    sendVideoAttachmentQuestionAnswer
}